/**
 * Tiny frontend logger.
 *
 * - In development (webpack replaces `process.env.NODE_ENV` with a string
 *   literal at build time) it delegates to console.*
 *   so devs can still see errors and traces.
 * - In production it is a no-op, which keeps the DevTools console clean and
 *   avoids leaking internal state to end users.
 *
 * Usage:
 *   import { logger } from '../lib/logger';
 *   try { ... } catch (e) { logger.error('X failed', e); }
 *
 * Later this can be swapped for Sentry / LogRocket by editing this file
 * only — the rest of the app is unaware.
 */

// webpack/CRA replaces `process.env.NODE_ENV` with a string literal at
// build time — no runtime `process` global is needed (and there isn't one
// in the browser). Do NOT wrap this in `typeof process !== 'undefined'`.
const isDev = process.env.NODE_ENV !== 'production';

const noop = () => {};

export const logger = {
  error: isDev ? (...args) => console.error(...args) : noop,
  warn: isDev ? (...args) => console.warn(...args) : noop,
  info: isDev ? (...args) => console.info(...args) : noop,
  debug: isDev ? (...args) => console.debug(...args) : noop,
};

export default logger;
